define('AddToWishlistPopup/addToWishlist',[
    "common/urlUtils",
    "common/formUtils",
    "common/alertMessage",
    "common/spinner"
],
function (urlUtils, formUtils, alertMessage, spinner) {

    const allProductOptionsSelector = "[id^=product_options_]";
    const allAddToListButtonsSelector = allProductOptionsSelector + " button.list, .add-all button.list";
    const allSelectListIconsSelector = allProductOptionsSelector + " button.list i, .add-all button.list i";
    const popupSelector = "#add-to-wishlist-popup";
    const formId = "#new-wishlist-form";

    var needToFetchLists = true;
    var itemAddedText;

    function isNumber(value) {

    }

    var optionsIndex = 0;
    function optionsSelector() {
        // this functions gives us the current product options selector
        if (isNaN(optionsIndex) && optionsIndex.startsWith("all_")) return ".add-all[data-options-index=" + optionsIndex + "]";
        else return "#product_options_" + optionsIndex;
    }

    var buttonsSpinner = {
        show: function () { spinner.show(optionsSelector() + " .add-to-spinner"); },
        hide: function () { spinner.hide(optionsSelector() + " .add-to-spinner"); }
    };

    var popupSpinner = {
        show: function () { spinner.show(popupSelector + " .spinner-wrapper"); },
        hide: function () { spinner.hide(popupSelector + " .spinner-wrapper"); }
    };

    function init() {
        $(allAddToListButtonsSelector).off("click").on("click", addToListClicked);
        $(popupSelector + " .create-new-list-item").off("click").on("click", createNewListClicked);
        $(popupSelector + " .new-wishlist-submit-button").off("click").on("click", createListButtonClicked);
        $(popupSelector + " .new-wishlist-cancel-button").off("click").on("click", hidePopup);
        $(popupSelector + " .continue-shopping-button").off("click").on("click", hidePopup);
        itemAddedText = $(popupSelector + " .item-added-text").text();

        autoTriggerAddToList();
    }

    function addToListClicked(event) {
        optionsIndex = $(this).closest("[data-options-index]").data("optionsIndex");
        if ($(popupSelector).data("isAuthenticated") === "False") {
            // User has to log in, only then they can add to list.
            buttonsSpinner.show();
            // Redirect to login page with redirectUrl that will bring the user back here after login or register.
            var loginPageUrl = $(popupSelector).data("loginPageUrl");
            var redirectAfterLoginUrl = urlUtils.putParamIntoUrl("addToListIndex", optionsIndex, window.location.href);
            if (!(isNaN(optionsIndex) && optionsIndex.startsWith("all_"))) {
                redirectAfterLoginUrl = urlUtils.putParamIntoUrl("addToListVariantSku", productOptions[optionsIndex].currentVariant.variantSku, redirectAfterLoginUrl);
            }
            window.location.href = urlUtils.putParamIntoUrl("redirectUrl", redirectAfterLoginUrl, loginPageUrl);
            return;
        }
        if (needToFetchLists) {
            getLists();
        }
        else {
            if ($(optionsSelector() + " button.list").data("plugin_webuiPopover")) {
                // popup already displayed for this button - hide it (we're using the button as toggle)
                hidePopup();
            }
            else {
                showPopup();
            }
        }
    }

    function createNewListClicked(event) {
        display("form");
    }

    function existingListClicked(event) {
        addToList({
            WishlistId: $(this).data("wishlistId"),
            WishlistName: $(this).data("wishlistName")
        });
    }

    function createListButtonClicked(event) {
        event.preventDefault();
        var postData = formUtils.collectFormData(formId);
        addToList(postData);
    }

    function getLists() {
        buttonsSpinner.show();

        $.ajax({
            type: "GET",
            url: "/customapi/Wishlist/GetAddToListWishlists",
            dataType: "json",
            data: null,
            success: function (data) {
                if (data.status === "OK") {
                    $(popupSelector + " .wishlist-items").empty().html(data.content);
                    $(popupSelector + " .wishlist-item").off("click").on("click", existingListClicked);
                    needToFetchLists = false;
                    showPopup();
                } else if (data.status === "ERROR") {
                    alertMessage.error(data.message);
                }
            },
            error: function (jq, status, errorThrown) {
                alertMessage.error(status + ": " + errorThrown);
            },
            complete: function () {
                buttonsSpinner.hide();
            }

        });
    }

    function display(what) {
        $(popupSelector + " .wishlist-popup-section").addClass("d-none");      // first hide all sections
        if (what === "confirmation") {
            $(popupSelector + " .added-to-wishlist").removeClass("d-none");
        }
        else if (what === "form") {
            $(popupSelector + " .create-list-form").removeClass("d-none");
            $(formId + " #new-wishlist-name").val("");
            $(formId + " #new-wishlist-name").focus();
        }
        else {
            // decide based on whether there are any lists already or not
            if ($(popupSelector + " .wishlist-item").length > 0) {
                // there are some wishlists to choose from
                $(popupSelector + " .choose-list").removeClass("d-none");
            }
            else {
                // there are no wishlists - display the form to enter the first one
                $(popupSelector + " .create-list-form").removeClass("d-none");
            }
        }
    }

    function showPopup() {
        display();
        var listButtonSelector = optionsSelector() + " button.list";
        $(listButtonSelector).webuiPopover({
            trigger: "manual",
            placement: "bottom-left",
            width: 400,
            type: "html",
            url: popupSelector,
            animation: "fade",
            multi: false,
            arrow: true,
            closeable: true,
            //dismissible: true,    works only if trigger is "click"
            onHide: function (popoverElement) {
                // Clone popup HTML to the end of the body because it will disappear when we destroy popover.
                // Popup will be cloned from there by WebuiPopover the next time we display it.
                $(popupSelector).clone(true).appendTo("body").hide();
                $(listButtonSelector).webuiPopover("destroy");
            }
        });
        $(listButtonSelector).webuiPopover("show");
    }

    function hidePopup(event) {
        $(optionsSelector() + " button.list").webuiPopover("hide");
    }

    function addToList(postData)
    {
        formUtils.clearInvalidFeedback(formId);
        popupSpinner.show();

        if (isNaN(optionsIndex) && optionsIndex.startsWith("all_")) {
            postData.BulkAdd = $(optionsSelector()).data("bulkAdd");
        } else {
            postData.Quantity = $(optionsSelector() + " .quantity-selector input").val();
            postData.ProductSku = productOptions[optionsIndex].productSku;
            postData.VariantSku = productOptions[optionsIndex].currentVariant.variantSku;
        }
        formUtils.useToken(postData);

        $.ajax({
            type: "POST",
            url: "/customapi/Wishlist/AddToWishlist",
            dataType: "json",
            data: postData,
            success: function (data) {
                if (data.status === "OK") {
                    $(popupSelector + " .item-added-text").text(
                        itemAddedText
                            .replace("{list_name}", postData.WishlistName)
                            .replace("{quantity}", data.numberOfItemsAdded)
                    );
                    $(popupSelector + " .added-to-wishlist .variant-display").empty().html(data.variantDisplay);
                    urlUtils.pushParamIntoLink("listId", data.wishlistId, $(popupSelector + " .go-to-list"));
                    if (!postData.WishlistId) needToFetchLists = true;  // new list was created, we'll need to refresh the list of lists
                    $(allSelectListIconsSelector).removeClass("d-none");  // display the icon because now we definitely have at least one list
                    display("confirmation");
                } else if (data.status === "ERROR") {
                    // Something's not right.
                    // Display the error messages (if any), and field validation messages (if any) and stay on the page.
                    if (data.message) alertMessage.error(data.message);
                    formUtils.displayInvalidFeedback(data.invalidFormFields, formId);
                }
            },
            error: function (jq, status, errorThrown) {
                alertMessage.error(status + ": " + errorThrown);
            },
            complete: function () {
                popupSpinner.hide();
            }

        });
        
    }

    function autoTriggerAddToList() {

        setTimeout(function () {
            // first we have to determine from query parameters which Add to List button to trigger
            var addToListIndex = urlUtils.popParamFromLink("addToListIndex");
            var addToListVariantSku = urlUtils.popParamFromLink("addToListVariantSku");
            if (!addToListIndex) return;

            optionsIndex = 0;

            if (isNaN(addToListIndex)) {
                optionsIndex = addToListIndex;
            } else if (productOptions[addToListIndex] && productOptions[addToListIndex].currentVariant.variantSku === addToListVariantSku) {
                // Product options index exists and the variant SKU matches.
                optionsIndex = addToListIndex;
            } else {
                // We'll try to find the product options by just variant SKU (because some product options indexes might have changed if the page was reloaded).
                optionsIndex = productOptions.findIndex((po) => po && po.currentVariant.variantSku === addToListVariantSku);
            }

            var buttonSelector = optionsSelector() + " button.list";
            if ($(buttonSelector).length) {
                $(buttonSelector).trigger("click");
                // scroll the button into view if needed
                var pageTop = $(window).scrollTop();
                var pageBottom = pageTop + $(window).height();
                var elementTop = $(buttonSelector).offset().top;
                var elementBottom = elementTop + $(buttonSelector).height();
                if (elementTop < pageTop || elementBottom > pageBottom) {
                    $("html,body").animate({ scrollTop: $(buttonSelector).offset().top - 80 });
                }
            }
        }, 1000);   // this has to be done with a slight delay because otherwise there are some problems with popup positioning
    }

    return {
        init: init
    };
});

